const translations = {
    en: {
        customize: {
            service_modal: {
                book_now_button: "BOOK NOW!",
                close_button: "CLOSE",
                book_error_message: "The reservation could not be completed, the service may no longer be available. Wait a few minutes and reload the page to try again",
                pending_service_warning_message: "As long as the reception does not confirm ${service}, it is not possible to forward other requests",
                free: "FREE",
                login_text: "Forgot your Booking Number? Don't worry!",
                your_login: "Your Login",
                call_reception: "Call our reception:"
            }
        }
    },
    de: {
        customize: {
            service_modal: {
                book_now_button: "JETZT BUCHEN!",
                close_button: "ENDEN",
                book_error_message: "The reservation could not be completed, the service may no longer be available. Wait a few minutes and reload the page to try again",
                pending_service_warning_message: "Solange der Empfang $ {service} nicht bestätigt, ist es nicht möglich, weitere Anfragen weiterzuleiten",
                free: "FREI",
                login_text: "Sie müssen Ihren Aufenthalt identifizieren, um eine zusätzliche Dienstleistungzu buchen. Bitte geben Sie eine gültige Buchungsnummer und einen Nachnamen ein.",
                your_login: "Your Login",
                call_reception: "Rufen sie unsere rezeption:"
            }
        }
    },
    es: {
        customize: {
            service_modal: {
                book_now_button: "RESERVE AHORA!",
                close_button: "CERRAR",
                book_error_message: "The reservation could not be completed, the service may no longer be available. Wait a few minutes and reload the page to try again",
                pending_service_warning_message: "Hasta que no se reciba una confirmacion de reserva, en relacion al servicio elegido ${service}, no serà posible enviar otra petición ",
                free: "GRATIS",
                login_text: "Para poder reservar un servicio adicional, es necesario añadir su número de reserva y su apellido ",
                your_login: "Your Login",
                call_reception: "Llama a nuestra recepción:"
            }
        }
    },
    fr: {
        customize: {
            service_modal: {
                book_now_button: "RÉSERVEZ MAINTENANT!",
                close_button: "FERMEZ",
                book_error_message: "The reservation could not be completed, the service may no longer be available. Wait a few minutes and reload the page to try again",
                pending_service_warning_message: "Tant que la réception ne confirme pas $ {service}, il n'est pas possible de transmettre d'autres demandes",
                free: "GRATUIT",
                login_text: "Pour reserver un service supplémentaire, il faut récupérer votre réservation. Entrez votre numero de confirmation et votre nom, s'il vous plaît.",
                your_login: "Your Login",
                call_reception: "Contactez la reception:"
            }
        }
    },
    it: {
        customize: {
            service_modal: {
                book_now_button: "PRENOTA ORA!",
                close_button: "CHIUDI",
                book_error_message: "Non è stato possibile completare la prenotazione, il servizio potrebbe non essere più disponibile. Attendi qualche minuto e ricarica la pagina per riprovare",
                pending_service_warning_message: "Finché dalla reception non confermano ${service}, non è possibile inoltrare altre richieste",
                free: "GRATIS",
                login_text: "Per prenotare un servizio aggiuntivo è necessario identificare il tuo soggiorno. Per favore inserisci un numero di prenotazione valido e il cognome.",
                your_login: "Il tuo Login",
                call_reception: "Chiama la reception:"
            }
        }
    }
};

export default translations;



// WEBPACK FOOTER //
// ./translations/customize/ServiceModal.js